var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandOperaStyleBlack = function SvgBrandOperaStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#svg_icon_BrandOperaStyleBlack__clip0_3953_125672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05 18.763c-1.328-1.567-2.187-3.88-2.244-6.48v-.566c.057-2.6.916-4.913 2.244-6.48 1.723-2.235 4.281-3.653 7.137-3.653 1.757 0 3.403.538 4.81 1.471A11.95 11.95 0 0 0 12.046 0H12C5.374 0 0 5.374 0 12c0 6.437 5.066 11.688 11.429 11.986Q11.713 24 12 24c3.072 0 5.875-1.154 7.997-3.053a8.67 8.67 0 0 1-4.81 1.469c-2.856 0-5.414-1.418-7.137-3.653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05 5.237c1.101-1.301 2.522-2.083 4.077-2.083 3.495 0 6.324 3.96 6.324 8.846s-2.832 8.846-6.324 8.846c-1.553 0-2.976-.784-4.077-2.083 1.723 2.235 4.281 3.653 7.137 3.653a8.68 8.68 0 0 0 4.81-1.469A11.97 11.97 0 0 0 24 12c0-3.554-1.546-6.749-4.003-8.945a8.65 8.65 0 0 0-4.81-1.471c-2.856 0-5.414 1.418-7.137 3.653"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandOperaStyleBlack__clip0_3953_125672"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandOperaStyleBlack);
export { ForwardRef as ReactComponent };